import React from 'react'
import { Radio } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { parseNumberObject } from 'utils/helpers'
import Tooltip from 'components/generic/tooltip'
import { dateFormatter } from 'utils/data-manipulation/valueFormatter'
import { transformStrToCapital } from 'utils/router'

export const useStyles = makeStyles(theme => ({
  root: {
    border: 'none',
    margin: 32,
    // remove header padding to align headers with column values
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: theme.spacing(0),
    },
    '& .MuiDataGrid-columnHeader': {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    '& .MuiDataGrid-cell': {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    '& .MuiDataGrid-columnSeparator': {
      visibility: 'hidden',
    },
    '& .MuiDataGrid-columnHeader:focus': {
      outline: 'none',
    },
    '& .MuiDataGrid-cell:focus': {
      outline: 'none',
    },
    '& .MuiDataGrid-cell:focus-within': {
      outline: 'none',
    },
  },
}))

export const getActionButtons = (setShowTransferModal, onHideModal, canSubmit) => [
  {
    id: 'select-transfer-button',
    text: 'Select',
    type: 'submit',
    variant: 'contained',
    disabled: !canSubmit,
    onClick: () => setShowTransferModal(true),
  },
  {
    id: 'exit-transfers-button',
    text: 'Cancel',
    onClick: () => onHideModal(),
  },
]

const makeMaterialsToolTip = materials => (
  <Tooltip content={materials?.toString()}>
    <>{materials.length > 1 ? 'Mixed' : materials.length === 0 ? '-' : materials[0]}</>
  </Tooltip>
)

export const getColumns = selected => [
  {
    field: 'radioOption',
    headerName: '',
    sortable: false,
    flex: 0.5,
    renderCell: params => <Radio checked={selected.length > 0 && selected[0] === params.id} value={params.id} />,
  },
  {
    field: 'transferNumber',
    headerName: 'Transfer #',
    flex: 1,
  },
  {
    field: 'date',
    headerName: 'Effective Date',
    flex: 1,
  },
  {
    field: 'sendingYard',
    headerName: 'Sending Yard',
    flex: 1,
    renderCell: params => transformStrToCapital(params.row.sendingYard) || '-',
  },
  {
    field: 'carrierNumber',
    headerName: 'Carrier #',
    flex: 1,
    renderCell: params => params.row.carrierNumber || '-',
  },
  {
    field: 'materials',
    headerName: 'Material',
    flex: 1,
    renderCell: params => {
      const { materials } = params.row
      const materialsFormated = materials?.map(material => material.materialTypeName)
      return makeMaterialsToolTip(materialsFormated)
    },
  },
  {
    field: 'netWeight',
    headerName: 'Net Weight',
    flex: 1,
    renderCell: params => parseNumberObject(params.row.netWeight, { format: 'weight' }),
  },
]

export const getRows = data =>
  (data?.Items || [])
    .slice()
    .sort((a, b) => new Date(b.status?.date) - new Date(a.status?.date))
    .map(transfer => ({
      ...transfer,
      date: dateFormatter(transfer.date),
    }))
